import { useState } from "react";
import { Lock } from "lucide-react";
import { Input } from "@/components/ui/input";
import { api, asset, errMsg, sessionId } from "@/lib/api";

export const tdvTrack = (tid, type, ref = "", label = "") => {
  api.post(`/public/tdv/${tid}/track`, { session_id: sessionId(), type, ref, label: (label || "").slice(0, 120) }).catch(() => {});
};

export function TdvUnlock({ data, onDone }) {
  const [f, setF] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const { tour, builder: b } = data;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try { await api.post(`/public/tdv/${tour.id}/unlock`, { email: f.email.trim(), password: f.password }); onDone(); }
    catch (x) { setErr(errMsg(x)); }
    setBusy(false);
  };
  return (
    <div className="fixed inset-0 bg-slate-950 text-white grid place-items-center p-6" data-testid="tdv-unlock">
      {tour.photo_url && <img src={asset(tour.photo_url)} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />}
      <form onSubmit={submit} className="relative w-full max-w-sm rounded-3xl glass-dark p-8 space-y-4 rise" data-testid="tdv-unlock-form">
        {b.logo_url ? <img src={asset(b.logo_url)} alt={b.name} className="h-10 w-auto" /> : <p className="font-semibold">{b.name}</p>}
        <div className="flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-white/60"><Lock className="w-3.5 h-3.5" /> Private tour</div>
        <h1 className="font-serif text-3xl">{tour.name}</h1>
        <Input required type="email" placeholder="Your email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className="h-12 bg-white/5 border-white/15 text-white placeholder:text-white/40" data-testid="tdv-unlock-email" />
        <Input required type="password" placeholder="Password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className="h-12 bg-white/5 border-white/15 text-white placeholder:text-white/40" data-testid="tdv-unlock-password" />
        {err && <p className="text-sm text-rose-300" data-testid="tdv-unlock-error">{err}</p>}
        <button disabled={busy} className="w-full h-12 rounded-full bg-white text-slate-900 font-semibold disabled:opacity-50" data-testid="tdv-unlock-submit">{busy ? "Checking…" : "Open tour"}</button>
      </form>
    </div>
  );
}
